import { Step } from '../components/steps/Step';
import { OnboardingFlows } from './common';

export const contentTypeFreelancerContentCreator: Step = {
    id: OnboardingFlows.UseCases,
    title: 'How do you plan to use D-ID?',
    showCondition: {
        stepId: OnboardingFlows.NewDepartment,
        selectedOption: 'Freelancer, Content Creator',
    },
    multiSelect: false,
    randomize: true,
    options: [
        {
            label: 'Product demo',
        },
        {
            label: 'Sales enablement',
        },
        {
            label: 'Customer training',
        },
        {
            label: 'Content marketing',
        },
        {
            label: 'Social media',
        },
        {
            label: 'Knowledge base',
        },
        {
            label: 'How-to guide',
        },
        {
            label: 'Employee training',
        },
        {
            label: 'Video production',
        },
        {
            label: 'Creator content',
        },
        {
            label: 'Interactive conversational Avatars',
        },
        {
            label: 'Other',
        },
    ],
};
